import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import { useNavigate, useParams } from "react-router-dom";
import { BlogPost } from "../const/types";
import cr from "../lib/request";
import ComponentSpinner from "../components/ComponentSpinner";
import BlogPostEditor from "../components/blogComponents/BlogPostEditor";
import { useToast } from "@chakra-ui/react";

export default function BlogPostEdit() {
  const { id } = useParams();
  const [data, setData] = useState<BlogPost | null>(null);
  const [categories, setCategories] = useState<any[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (id) {
      setLoading(true);
      const url = `api/blog/post/${id}/show`;
      const categoriesUrl = `api/blog/allcategories`;

      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
          toast({
            title: "Maaf Terjadi Kesalahan",
            status: "error",
            duration: 10000,
            isClosable: true,
          });
          navigate("/blog/post");
        })
        .finally(() => {
          setLoading(false);
        });

      cr.get(categoriesUrl)
        .then((r) => {
          if (r.status === 200) {
            setCategories(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
          toast({
            title: "Maaf Terjadi Kesalahan",
            status: "error",
            duration: 10000,
            isClosable: true,
          });
          navigate("/blog/post");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, navigate, toast]);

  return (
    <>
      {!loading && data && categories ? (
        <>
          <NavHeader la={"back"} label={"Edit Blog"} />

          <BlogPostEditor data={data} categories={categories} />
        </>
      ) : (
        <ComponentSpinner flex={1} />
      )}
    </>
  );
}
